// extracted by mini-css-extract-plugin
export default {"root":"PlayWithTimer_root__S4WFl","icon":"PlayWithTimer_icon__Qk0wU"};